import React, { useState, useEffect } from 'react';

const UserEdit = ({ selectedUser }) => {
  const [newRole, setNewRole] = useState(selectedUser?.role || '');
  const [blockStatus, setBlockStatus] = useState(selectedUser?.blockStatus || '');
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(selectedUser?.subscriptionEndDate || '');
  const [plan, setPlan] = useState(selectedUser?.currentPlan || ''); // Use currentPlan here
  const [paymentMethod, setPaymentMethod] = useState(selectedUser?.paymentMethod || '');
  const [paymentStatus, setPaymentStatus] = useState(selectedUser?.paymentStatus || '');

  useEffect(() => {
    if (selectedUser) {
      setNewRole(selectedUser.role || '');
      setBlockStatus(selectedUser.blockStatus || '');
      setSubscriptionEndDate(selectedUser.subscriptionEndDate || '');
      setPlan(selectedUser.currentPlan || ''); // Update to currentPlan
      setPaymentMethod(selectedUser.paymentMethod || '');
      setPaymentStatus(selectedUser.paymentStatus || '');
    }
  }, [selectedUser]);

  const handleUpdateUser = async () => {
    // Confirmation popup before updating
    const isConfirmed = window.confirm('Are you sure you want to update this user?');

    if (!isConfirmed) {
      return; // If the user cancels, stop the update process
    }

    // Create an object for the updated fields
    const userData = {
      userId: selectedUser.user._id,
      ...(newRole && newRole !== selectedUser.role && { role: newRole }), // Only include if changed
      ...(blockStatus && blockStatus !== selectedUser.blockStatus && { blockStatus }), // Only include if changed
      ...(subscriptionEndDate && subscriptionEndDate !== selectedUser.subscriptionEndDate && { subscriptionEndDate }), // Only include if changed
      ...(plan && plan !== selectedUser.currentPlan && { currentPlan: plan }), // Only include if changed
      ...(paymentMethod && paymentMethod !== selectedUser.paymentMethod && { paymentMethod }), // Only include if changed
      ...(paymentStatus && paymentStatus !== selectedUser.paymentStatus && { paymentStatus }), // Only include if changed
    };

    // Remove any undefined fields (this will clean up the userData object)
    Object.keys(userData).forEach(key => userData[key] === undefined && delete userData[key]);

    try {
      const response = await fetch('/api/users/update', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const result = await response.json();

      if (response.ok) {
        alert('User updated successfully!');
      } else {
        console.error('Error:', result.message);
        alert('Failed to update user.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Edit User</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Name</label>
          <input
            type="text"
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={selectedUser?.name || ''}
            disabled
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Role</label>
          <input
            type="text"
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={newRole}
            onChange={(e) => setNewRole(e.target.value)}
            placeholder={selectedUser?.role || 'Enter new role'}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Block Status</label>
          <select
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={blockStatus}
            onChange={(e) => setBlockStatus(e.target.value)}
          >
            <option value="">{selectedUser?.blockStatus || 'Select block status'}</option>
            <option value="Active">Active</option>
            <option value="Blocked">Blocked</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Subscription End Date</label>
          <input
            type="date"
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={subscriptionEndDate}
            onChange={(e) => setSubscriptionEndDate(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Current Plan</label>
          <input
            type="text"
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Payment Method</label>
          <input
            type="text"
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Payment Status</label>
          <select
            className="w-full p-3 rounded-lg border border-gray-300 shadow-sm"
            value={paymentStatus}
            onChange={(e) => setPaymentStatus(e.target.value)}
          >
            <option value="">{selectedUser?.paymentStatus || 'Select payment status'}</option>
            <option value="Paid">Paid</option>
            <option value="Pending">Pending</option>
            <option value="Refunded">Refunded</option>
          </select>
        </div>
      </div>
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-sm hover:bg-blue-600 transition duration-200 ease-in-out"
        onClick={handleUpdateUser}
      >
        Update
      </button>
    </div>
  );
};

export default UserEdit;
